/* Package arithmetic and room geometry. No product facts or suitability are inferred. */
(() => {
  const price = value => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4}).format(value);
  const number = value => new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(value);
  const read = (form, key) => {
    const raw = form.elements.namedItem(key)?.value;
    return raw === '' || raw == null ? NaN : Number(raw);
  };
  const show = (form, heading, lines) => {
    const output = form.querySelector('[data-mk-result]');
    output.replaceChildren();
    const title = document.createElement('strong');
    title.textContent = heading;
    output.append(title);
    for (const line of lines) {
      const p = document.createElement('p');
      p.textContent = line;
      output.append(p);
    }
  };
  document.querySelectorAll('[data-mk-cost]').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const factors = {oz: 1, lb: 16, g: 1 / 28.349523125};
      const packs = ['a', 'b'].map(side => {
        const totalPrice = read(form, `${side}-price`);
        const count = read(form, `${side}-count`);
        const weight = read(form, `${side}-weight`);
        const ounces = count * weight * factors[form.elements.namedItem(`${side}-unit`).value];
        return {totalPrice, count, weight, ounces, perOz: totalPrice / ounces, perItem: totalPrice / count};
      });
      if (packs.some(p => ![p.totalPrice, p.count, p.weight, p.ounces, p.perOz, p.perItem].every(Number.isFinite) || p.totalPrice < 0 || p.count < 1 || !Number.isInteger(p.count) || p.weight <= 0 || p.ounces <= 0)) {
        show(form, 'Check the package details.', ['Use a nonnegative price, a whole item count, and a positive net weight.']);
        return;
      }
      const [a, b] = packs;
      let heading = 'The packages have the same cost per ounce.';
      if (Math.abs(a.perOz - b.perOz) > Number.EPSILON * Math.max(1, a.perOz, b.perOz)) {
        const cheaper = a.perOz < b.perOz ? 'A' : 'B';
        const difference = (1 - Math.min(a.perOz, b.perOz) / Math.max(a.perOz, b.perOz)) * 100;
        heading = `Package ${cheaper} costs ${number(difference)}% less per ounce.`;
      }
      show(form, heading, packs.map((p, i) => `Package ${i === 0 ? 'A' : 'B'}: ${number(p.ounces)} oz total · ${price(p.perOz)} per oz · ${price(p.perItem)} per item.`));
    });
  });
  document.querySelectorAll('[data-mk-space]').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const [rl, rw, bl, bw, el, ew] = ['room-length', 'room-width', 'box-length', 'box-width', 'extra-length', 'extra-width'].map(key => read(form, key));
      if (![rl, rw, bl, bw, el, ew].every(Number.isFinite) || [rl, rw, bl, bw].some(v => v <= 0) || el < 0 || ew < 0) {
        show(form, 'Check the measurements.', ['Enter positive room and box dimensions, and zero or positive extra allowances.']);
        return;
      }
      const unit = form.elements.namedItem('unit').value === 'cm' ? 'cm' : 'in';
      const fits = bl + el <= rl && bw + ew <= rw;
      const rotated = bw + el <= rl && bl + ew <= rw;
      const heading = fits ? 'The footprint fits with your entered allowances.' : rotated ? 'The rotated footprint fits with your entered allowances.' : 'The footprint exceeds your space in both orientations.';
      const lines = [`In the entered orientation, you need ${number(bl + el)} × ${number(bw + ew)} ${unit}. Your space is ${number(rl)} × ${number(rw)} ${unit}.`];
      if (fits) lines.push(`Space remaining beyond those allowances: ${number(rl - bl - el)} ${unit} along the length and ${number(rw - bw - ew)} ${unit} along the width.`);
      if (!fits && rotated) lines.push(`Rotated, you need ${number(bw + el)} × ${number(bl + ew)} ${unit}. Check that the new entrance, drawer, and lid directions work in the room.`);
      lines.push('Next, check usable interior dimensions, entry height, and lid clearance separately. A floor-space fit does not establish fit for your cat.');
      show(form, heading, lines);
    });
  });
})();
